import * as React from "react";
import { Button } from 'reactstrap';
import { Constants } from "../../constants";

interface NoticeProps {
    onAction: () => void
}

class NoticeScreen extends React.Component<NoticeProps, {}> {
    constructor(props:any) {
        super(props);

        this.onAcceptNotice = this.onAcceptNotice.bind(this);
    }

    onAcceptNotice() {
        this.props.onAction();
    }

    render() {
        return (
            <div className="noticeWrapper">
                <h1>{Constants.NOTICE_TITLE}</h1>
                <div>
                    {Constants.NOTICE_LINE1}
                </div>
                <div>
                    {Constants.NOTICE_LINE2}
                </div>
                <div>
                    {Constants.NOTICE_LINE3}
                </div>
                <div>
                    {Constants.NOTICE_LINE4}
                </div>
                <div>
                    <Button color="primary" onClick={this.onAcceptNotice} >{Constants.NOTICE_ACCEPT}</Button>
                </div>
            </div>
        );
    }
}

export default NoticeScreen;